import { GlBadge, GlTooltipDirective } from '@gitlab/ui';
export default {
    name: 'HiddenBadge',
    components: {
        GlBadge
    },
    directives: {
        GlTooltip: GlTooltipDirective
    }
};
